import React from 'react';
import Tetris from './components/tetris.js';


const App = () => (
  <div className="app">
    <Tetris/>
  </div>

)

export default App;